module.exports = __webpack_public_path__ + "img/21_48.ee57239b.png";